<template>
  <div class="game-cards">
    <GameCard
      v-for="card in props.gameCards"
      :key="card.gameId"
      :game="card"
      :show-player-count="showPlayerCount"
      class="card"
    />
  </div>
</template>

<script lang="ts" setup>
import GameCard from '../GameCard/GameCard.vue'
import type { Game } from '../../types'

const props = withDefaults(
  defineProps<{
    gameCards: Game[]
    showPlayerCount?: boolean
  }>(),
  {
    showPlayerCount: true,
  },
)
</script>

<style lang="css" scoped>
.game-cards {
  position: relative;

  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: auto;
  gap: var(--spacing-200) var(--spacing-125);
}

.card {
  min-width: 0;
}
</style>
